import { useEffect, useState } from 'react';
import { Alert, Skeleton, theme } from 'antd';
import { useBoletaPago } from '../api/usePagos';
import { useT } from '../../../locales';

export interface BoletaViewerProps {
  id: number;
}

export function BoletaViewer({ id }: BoletaViewerProps) {
  const t = useT();
  const { token } = theme.useToken();
  const { data: blob, isLoading, isError } = useBoletaPago(id);
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!blob) {
      setObjectUrl(null);
      return;
    }

    const url = URL.createObjectURL(blob);
    setObjectUrl(url);

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [blob]);

  if (isLoading) {
    return (
      <div role="status" aria-live="polite" aria-busy="true">
        <Skeleton active title={false} paragraph={{ rows: 7 }} />
      </div>
    );
  }

  if (isError || !objectUrl) {
    return <Alert type="error" showIcon title={t('pages.pagos.boletaError')} />;
  }

  return (
    <figure
      style={{
        display: 'flex',
        justifyContent: 'center',
        margin: 0,
        padding: token.paddingSM,
        borderRadius: token.borderRadiusLG,
        background: token.colorFillTertiary,
      }}
    >
      <img
        src={objectUrl}
        alt={t('pages.pagos.boletaAlt')}
        style={{
          display: 'block',
          width: '100%',
          maxHeight: 'min(65vh, 640px)',
          objectFit: 'contain',
          borderRadius: token.borderRadius,
        }}
      />
    </figure>
  );
}
